// extracted by mini-css-extract-plugin
export default {"responseField":"style__responseField___h1KS3","responseFieldDraggableOver":"style__responseFieldDraggableOver___nWIFX","tableCell":"style__tableCell___kwasd"};